/* eslint-disable */
/**
 * Класс для работы с API. При добавлении нового метода обязательно описание
 * и ссылка на спеку на apiok.ru
 *
 *
 *
 * @type {ApiHelper|*|{}}
 */


/*global ApiHelper: true */
var ApiHelper = ApiHelper || {};

(function (external) {

    'use strict';

    /* =============== PRIVATE ================== */
    var logEnabled = false;
    var responseFormat = "json";

    function logToConsole(msg) {
        if (logEnabled) {
            console.log(msg);
        }
    }


    /* =============== PUBLIC UTIL =============== */

    /**
     * Принудительно установить указанный апи-сервер
     * @param apiServer
     */
    external.setApiServer = function(apiServer) {
        var appParams = FAPI.Util.getRequestParameters();
        appParams.api_server = apiServer;
        FAPI.Util.getRequestParameters = function() {
            return appParams;
        };
    };

    /**
     * Логирование событий на консоль
     * @param enabled
     */
    external.setLogEnabled = function (enabled) {
        logEnabled = enabled;
    };

    /**
     * Формат ответа сервера JSON/XML
     * @param format
     */
    external.setResponseFormat = function (format) {
        responseFormat = format;
    };

    /* =============== PUBLIC API =============== */

    /**
     * Получение локализованных ресурсов из PTS
     *
     * https://apiok.ru/wiki/pages/viewpage.action?pageId=52592646
     * Приложение должно иметь аттрибут INTERNAL, а так же права на доступ в апи translations.get,
     * @see forticom-api/app.translations.whitelist.packages
     *
     * @param pkg
     * @param keys список ключей или '*' для получения всех ключей
     * @param locale язык перевода ru/en, null - вернется язык выбранный пользователем
     * @param callback
     */
    external.getTranslations = function (callback, pkg, keys, locale) {
        var params = {
            'method': 'translations.get',
            'package': pkg,
            'keys': keys
        };
        // параметр нужен только если специально запрашиваем определенный язык
        // по умолчанию выбранный пользователем
        if (locale) {
            params = locale;
        }
        logToConsole(params);
        FAPI.Client.call(params, callback);
    };

    /**
     * Этот метод возвращает количество OK на балансе текущего пользователя.
     * https://apiok.ru/wiki/display/api/payment.getUserAccountBalance+ru
     * @param callback
     */
    external.getUserAccountBalance = function (callback) {
        var params = {
            'method': 'payment.getUserAccountBalance'
        };
        logToConsole(params);
        FAPI.Client.call(params, callback);
    };


    /**
     * Логирование статистики
     *
     * https://wiki.odkl.ru/pages/viewpage.action?pageId=15311346
     * @param appParams - параметры сессии
     * @param code код для логирования статистики. У каждого события должен быть уникальный в рамках приложения код
     */
    external.logStatistic = function (code, appParams) {
        console.log("statistic: " + code);
        setTimeout(function () {
            var params = {
                'method': 'log.clientLog',
                'uid': appParams.logged_user_id,
                'application_key': appParams.application_key,
                'format': responseFormat,
                'session_key': appParams.session_key,
                'code': code,
                'time': 0
            };
            logToConsole(params);
            FAPI.Client.call(params, function (status, data, error) {
            });
        }, 30);
    };

    /**
     * Отправить нотификацию пользователю
     *
     * https://apiok.ru/wiki/display/api/notifications.sendSimple+ru
     * @param callback
     * @param appParams - параметры сессии
     */
    external.sendFromUser = function (callback, uid, text, appParams) {
        var params = {
            "method": "notifications.sendFromUser",
            "to_uid": uid,
            "application_key": appParams.application_key,
            "format": responseFormat,
            "session_key": appParams.session_key,
            "text": text
        };
        logToConsole(params);
        FAPI.Client.call(params, callback);
    };

    /**
     * Получить активные подарки пользователя (те, что показаны на аватарке)
     *
     * https://apiok.ru/wiki/display/api/presents.getActive+ru
     * @param callback
     * @param fields - поля, которые должны вернуть АПИ
     * @param fid - ид пользователя по которому запросить подарки
     * @param appParams - параметры сессии
     */
    external.presentsGetActive = function (callback, fields, fid, appParams) {
        var params = {
            "method": "presents.getActive",
            "application_key": appParams.application_key,
            "format": responseFormat,
            "session_key": appParams.session_key,
            "fid": fid,
            "fields": fields
        };
        logToConsole(params);
        FAPI.Client.call(params, callback);
    };

    /**
     * Получить настройки из PMS forticom-api/app.local.settings
     *
     * https://apiok.ru/wiki/pages/viewpage.action?pageId=80052782
     * @param callback
     * @param fields можно указать APP для получения настроек по id приложения
     * @param appParams - параметры сессии
     */
    external.getSettings = function (callback, fields, appParams) {
        var params = {
            "method": "settings.get",
            "uid": appParams.logged_user_id,
            "application_key": appParams.application_key,
            "format": responseFormat,
            "session_key": appParams.session_key,
            "fields": fields
        };
        logToConsole(params);
        FAPI.Client.call(params, callback);
    };

    /**
     * Получение друзей пользователя
     *
     * https://apiok.ru/wiki/display/api/friends.get
     * @param callback
     * @param sortType - либо null, либо 'PRESENT' (friends sorted on the basis of how often it gives gifts)
     * @param appParams - параметры сессии
     */
    external.friendsGet = function (callback, sortType, appParams) {
        var params = {
            "method": "friends.get",
            "application_key": appParams.application_key,
            "format": responseFormat,
            "session_key": appParams.session_key
        };
        if (sortType) {
            params.sort_type = sortType;
        }
        logToConsole(params);
        FAPI.Client.call(params, callback);
    };

    /**
     * Получение информации о пользователе
     *
     * https://apiok.ru/wiki/display/api/users.getInfo
     * @param callback
     * @param uids - список пользователей, разделенный запятыми
     * @param fields - поля, например, имя, пол, возраст, аватарка
     * @param appParams - параметры сессии
     */
    external.usersGetInfo = function (callback, uids, fields, appParams) {
        var params = {
            "method": "users.getInfo",
            "application_key": appParams.application_key,
            "uids": uids,
            "fields": fields,
            "format": responseFormat,
            "session_key": appParams.session_key
        };
        logToConsole(params);
        FAPI.Client.call(params, callback);
    };

    /**
     * Получение подарков по id
     *
     * https://apiok.ru/wiki/display/api/presents.get+ru
     * @param callback
     * @param presentIds - список id, разделенных запятыми
     * @param fields - поля подарка
     * @param appParams - параметры сессии
     */
    external.presentsGet = function (callback, presentIds, fields, appParams) {
        var params = {
            'method': 'presents.get',
            'present_ids': presentIds,
            'fields': fields
        };
        logToConsole(params);
        FAPI.Client.call(params, callback);
    };

    /**
     * Запостить медиатопик с помощью рест-метода апи.
     * Пример:
     * var attachment = {
            media: [
                {
                    type: "app",
                    images: [
                        {
                            url:"http://r.mradx.net/img/38/F3C336.jpg",
                            mark: "presentId="+app.sharingPresentId,
                            title: "Страница подарка"
                        }
                    ]
                },
                {
                    "type": "text",
                    "text": "Голосуй за этот подарок в конкурсе подарков \"Зверята\""
                }
            ]
        };
        ApiHelper.mediatopicPost(JSON.stringify(attachment), function(result, data) {
            if (result == 'ok') {
            }
        });
     *
     * @param {string} attachment - сериализованный в json объект, содержимое медиатопика
     * @param {boolean} setStatus
     * @param {function} callback
     * @param {object} appParams
     */
    external.mediatopicPost = function(attachment, callback, setStatus, type, appParams) {
        var params = {
            "method": "mediatopic.post",
            "application_key": appParams.application_key,
            "format": "json",
            "session_key": appParams.session_key,
            "attachment": attachment
        };
        if (typeof(setStatus) === "boolean") {
            params.set_status = setStatus;
        }
        if (type) {
            params.type = type;
        }
        FAPI.Client.call(params, callback);
    };

})(ApiHelper);
/* eslint-enable */